import { Collapse } from 'bootstrap'
import '../scss/styles.scss'
import Rails from '@rails/ujs'

import '@fortawesome/fontawesome-free/css/all.css'

import Search from '../Search.svelte'

const app = []
const comparisonReturnStorageKey = 'fantacalcio.playerComparison.lastCompletedAt'
const comparisonReturnMinimumMs = 30 * 60 * 1000
const comparisonReturnMaximumMs = 30 * 24 * 60 * 60 * 1000

function analyticsParams (element, attribute = 'analyticsParams') {
  const value = element.dataset[attribute]
  if (!value) return {}

  try {
    return JSON.parse(value)
  } catch (error) {
    return {}
  }
}

function trackAnalyticsEvent (name, params = {}) {
  if (name && typeof window.gtag === 'function') {
    window.gtag('event', name, params)
  }
}

async function copyComparisonUrl (url) {
  if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
    try {
      await navigator.clipboard.writeText(url)
      return
    } catch (error) {
      // Some browsers expose the Clipboard API but deny it in restricted contexts.
    }
  }

  const input = document.createElement('textarea')
  input.value = url
  input.setAttribute('readonly', '')
  input.style.position = 'fixed'
  input.style.opacity = '0'
  document.body.appendChild(input)
  input.select()
  const copied = document.execCommand('copy')
  input.remove()
  if (!copied) throw new Error('Unable to copy comparison URL')
}

function enhanceComparisonSharing () {
  document.querySelectorAll('[data-comparison-share-url]').forEach(function (button) {
    button.addEventListener('click', async function () {
      const status = button.parentElement.querySelector('[data-comparison-share-status]')

      try {
        if (typeof navigator.share === 'function') {
          try {
            await navigator.share({title: button.dataset.comparisonShareTitle, url: button.dataset.comparisonShareUrl})
          } catch (error) {
            if (error.name === 'AbortError') return
            await copyComparisonUrl(button.dataset.comparisonShareUrl)
          }
        } else {
          await copyComparisonUrl(button.dataset.comparisonShareUrl)
        }
        if (status) status.textContent = status.dataset.successMessage
        trackAnalyticsEvent(button.dataset.comparisonShareEvent)
      } catch (error) {
        if (status) status.textContent = status.dataset.errorMessage
      }
    })
  })
}

function trackComparisonReturns () {
  const comparison = document.querySelector('[data-comparison-return-event]')
  if (!comparison) return

  try {
    const now = Date.now()
    const previousVisit = Number(window.localStorage.getItem(comparisonReturnStorageKey))
    const elapsed = now - previousVisit

    if (previousVisit && elapsed >= comparisonReturnMinimumMs && elapsed <= comparisonReturnMaximumMs) {
      trackAnalyticsEvent(
        comparison.dataset.comparisonReturnEvent,
        analyticsParams(comparison, 'comparisonReturnParams')
      )
    }
    window.localStorage.setItem(comparisonReturnStorageKey, now.toString())
  } catch (error) {
    // The comparison remains fully usable when storage is unavailable.
  }
}

async function enhancePlayerComparisonSelects () {
  const elements = document.querySelectorAll('.player-comparison-select')
  if (elements.length === 0) return

  try {
    const [{ default: TomSelect }] = await Promise.all([
      import('tom-select'),
      import('tom-select/dist/css/tom-select.bootstrap5.css')
    ])

    elements.forEach(function (element) {
      new TomSelect(element, {
        create: false,
        placeholder: element.getAttribute('placeholder'),
        searchField: ['text'],
        selectOnTab: true
      })
    })
  } catch (error) {
    console.error('Unable to enhance player comparison selects', error)
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const elements = document.getElementsByClassName('search-svelte')
  for (var i = 0; i < elements.length; i++) {
    elements[i].innerHTML = ''
    const search = new Search({ target: elements[i] })
    app.push(search)
  }
  // https://github.com/rails/rails/blob/main/actionview/app/assets/javascripts/rails-ujs.js
  if (window._rails_loaded != true) {
    Rails.start()
  }

  enhancePlayerComparisonSelects()
  enhanceComparisonSharing()
  trackComparisonReturns()

  document.querySelectorAll('[data-analytics-view-event]').forEach(function (element) {
    trackAnalyticsEvent(element.dataset.analyticsViewEvent, analyticsParams(element))
  })

  document.addEventListener('submit', function (event) {
    const analyticsEvent = event.target.dataset.analyticsEvent
    trackAnalyticsEvent(analyticsEvent, analyticsParams(event.target))
  })

  document.addEventListener('click', function (event) {
    const target = event.target.closest('[data-analytics-event]')
    if (target) trackAnalyticsEvent(target.dataset.analyticsEvent, analyticsParams(target))
  })
})

export default app
